<template>
  <!-- 微信支付 -->
  <div v-show="active > 0">
    <el-steps :active="activeIndex" finish-status="success" simple>
      <el-step title="扫码授权"></el-step>
      <el-step title="填写信息"></el-step>
      <el-step title="支付验证"></el-step>
    </el-steps>
    <!--  -->
    <div v-if="active==1" class="wxpay-main">
        <div  id="wxCodeLink" class="wxpay-child1"></div>
        <h5>使用服务号管理员的微信号扫描二维码授权</h5>
        <a target="_blank" href="https://www.yuque.com/docs/share/5a6e6356-c923-4303-9dbb-4f9515975970">查看帮助文档</a>
        <div class="btn">
            <el-button @click="getAuth('refer')" size="small">刷新二维码</el-button>
            <el-button size="small" @click="nextHandle()" type="primary">下一步</el-button>
        </div>
    </div>
    <div  v-if="active==2" class="wxpay-main">
        <el-form  :model="form" label-width="180px">
            <el-form-item label="AppID">
                <el-input type="text" v-model="form.app_id"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item label="商户号">
                <el-input type="text" v-model="form.mch_id"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item label="微信商户API密钥">
                <el-input type="text" v-model="form.key"></el-input>
            </el-form-item>
        </el-form>
        <a target="_blank" href="https://www.yuque.com/docs/share/5a6e6356-c923-4303-9dbb-4f9515975970">查看帮助文档</a>
        <div class="btn">
            <el-button @click="preHandle()" size="small">上一步</el-button>
            <el-button size="small" @click="saveWxPay()" type="primary">下一步</el-button>
        </div>
    </div>
    <!--  -->
    <div  v-show="active==3" class="wxpay-main">
        <div v-show="payBool">
            <div  id="wxCodeLink2" class="wxpay-child1"></div>
            <h5>请扫描二维码支付0.01元，完成账号验证</h5>
            <div class="btn">
                <el-button @click="preHandle()" size="small">上一步</el-button>
                <el-button size="small" @click="savehandle()" type="primary">完成</el-button>
            </div>
        </div>
        <div v-show="!payBool">
            <h5>账号配置成功，请联系管理员开通。</h5>
            <div class="text">
                <h6>AppID：{{form.app_id}}</h6>
                <h6>商户号：{{form.mch_id}}</h6>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { getAuthUrl,getPayConfig,updatePayConfig,conGetUser, } from "@/api/consultant";

import { isMain } from "@u/tools";
export default {
    data(){
        return{
            active:1,
            activeIndex:0,
            qrshow:true,
            qrcode:{},
            // 获取配置信息
            config:{},
            form:{
                app_id:'',
                mch_id:'',
                key:''
            },
            ismain:isMain(),
            // 是否完成支付验证
            payBool:true,
            qrshow2:true,
            qrcode2:{}
        }
    },
    methods:{
        // 验证是否支付成功
        savehandle(){
            getPayConfig().then(data=>{
                if(data.error>0){
                    this.$message(data.msg);
                    return
                }
                // 是否已支付
                if(data.item.status==1){
                    this.payBool = false;
                    this.activeIndex +=1; 
                    return
                }else{
                    this.$message('请先完成支付！');
                }
            });
        },
        // 支付二维码生成
        payQrcodeHandle(){
            if(this.qrshow2){
                this.qrcode2 = new QRCode(document.getElementById("wxCodeLink2"),{
                    width: '260',
                    height: '260',
                    correctLevel:QRCode.CorrectLevel.H
                });
                this.qrshow2 = false;
            }
            this.qrcode2.makeCode(`https://open.xjy.cn/${this.ismain?'main':'test'}/testpay?pay_config_id=${this.config.id}`);
        },
        // 提交支付配置信息
        saveWxPay(){
            if(!this.form.app_id || !this.form.mch_id || !this.form.key){
                this.$message('信息不能为空!');
                return
            }
            this.$showLoading();
            updatePayConfig(this.form).then(data=>{
                this.$hideLoading();
                if(data.error>0){
                    this.$message(data.msg);
                    return
                }
                this.nextHandle();
                this.payQrcodeHandle();
            })
        },
        // 上一步
        preHandle(){
            this.$forceUpdate()
            if(this.active<=1){
                return
            }
            this.activeIndex-=1;
            this.active-=1;
            if(this.active<=1){
                this.qrshow = true;
                this.getAuth();
            }
        },
        // 下一步
        nextHandle(){
            this.$forceUpdate()
            if(this.active>=3){
                return
            }
            this.activeIndex+=1;
            this.active+=1;

            if(this.active>1){
               this.qrcode = {}; 
            }
        },
        // 获取授权地址
        getAuth(bool){
            this.$showLoading();
            getAuthUrl().then(data=>{
                if(data.error>0){
                    this.$message(data.msg);
                    return
                }
                
                if(this.qrshow){
                    this.qrcode = new QRCode(document.getElementById("wxCodeLink"),{
                        width: '260',
                        height: '260',
                        correctLevel:QRCode.CorrectLevel.H
                    });
                    this.qrshow = false;
                }
                // this.$forceUpdate()
                // this.$nextTick(()=>{
                    this.qrcode.makeCode(data.url);
                // });
                
                this.$hideLoading();
            });
        },
        // 初始获取数据
        pullData(){

            getPayConfig().then(data=>{
                if(data.error>0){
                    this.$message(data.msg);
                    return
                }
                this.config = data.item;
                // 是否已支付
                if(data.item.status==1){
                    this.form.app_id = String(this.config.app_id);
                    this.form.mch_id = String(this.config.mch_id);
                    this.activeIndex = 2;
                    this.active = 3;
                    this.payBool = false;
                    return
                }
                
                if(this.config.app_id || this.config.mch_id){
                    this.form.app_id = String(this.config.app_id);
                    this.form.mch_id = String(this.config.mch_id);
                    this.form.key = String(this.config.key);
                    this.activeIndex = 1;
                    this.active = 2;
                }else{
                    // this.active = 1;
                    this.getAuth();
                }
            });
            
            
            
        }
    },
    created(){
        conGetUser().then(res=>{
          if(res.error != 0) {
            return;
          }
          let user = res.item;
          // this.showBuy = user.show_buy;
          // this.showWhitelist = user.show_whitelist;
          // this.showWxpay = user.show_wxpay;
          if(!user.show_wxpay) {
            this.active = 0;
            this.$message('未开通微信支付功能');
            return;
          }

          this.pullData();
        });
    }
}
</script>

<style lang="scss" scoped>
.wxpay-main{
    background-color:#ffffff;
    margin-top:40px;
    padding:30px;
    color:#333333;
    text-align:center;
    .wxpay-child1{
        width:260px;
        height:260px;
        margin:30px auto 30px;
    }
    h5{
        font-size:14px;
        margin:20px auto;
    }
    a{
        font-size:12px;
        color: #169BD5;
    }
    .btn{
        margin:15px auto 0;
    }
}
</style>